<div class="dashboard-container unselectable">
  <div class="dashboardheader unselectable">
    <h1><b>Dashboard</b></h1>
    <div class="header-actions">
      <mat-checkbox
        [(ngModel)]="isSmallPractice"
        (change)="onSmallPracticeChange()"
        class="small-practice-checkbox"
      >
        Small Practice
      </mat-checkbox>
      <mat-slide-toggle
        *ngIf="isMultiOrgTin$ | async"
        [(ngModel)]="isTinAggregationEnabled"
        (change)="onTinAggregationChange()"
        class="tin-aggregation-toggle"
        matTooltip="Roll up measures across all organizations sharing this TIN. Patient-level drill-down is unavailable in this view."
      >
        TIN Aggregation
      </mat-slide-toggle>
      <button
        mat-raised-button
        color="primary"
        class="export-btn"
        (click)="onExport()"
      >
        <mat-icon>cloud_download</mat-icon> EXPORT
      </button>
    </div>
  </div>


  <!-- Tabs -->
  <mat-tab-group
    mat-align-tabs="start"
    (selectedTabChange)="selectTab($event.tab.textLabel.toLowerCase())"
  >
    <mat-tab label="All Measures"></mat-tab>
    <mat-tab label="MIPS Measures"></mat-tab>
    <mat-tab label="MVP Measures"></mat-tab>
  </mat-tab-group>

  <ng-container
    *ngIf="selectedTab === 'mips measures' || selectedTab === 'mvp measures'"
  >
    <div class="guage-container">
      <div *ngIf="reweightingLoading$ | async" class="reweighting-loading-indicator">
        <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
        <span>Recalculating...</span>
      </div>
      <app-mips-gauges [gauges]="gauges" (reweightToggle)="onGaugeReweightToggle($event)"></app-mips-gauges>
      <div class="footer-disclaimer" *ngIf="selectedTab === 'mvp measures'">
        <p>
          Population health measures (calculated automatically via
          administrative claims) can earn between 1 and 10 points based on
          comparison to a performance period benchmark.
        </p>
      </div>
    </div>
  </ng-container>

  <mat-divider class="section-divider"></mat-divider>

  <!-- Filters -->
  <div class="filters-container unselectable">
    <div class="filters">
      <mat-form-field appearance="outline">
        <mat-label>Measure Selection</mat-label>
        <mat-select
          multiple
          [(ngModel)]="filters.measureSelection"
          panelClass="searchable-panel"
        >
          <mat-option disabled>
            <ngx-mat-select-search
              [formControl]="measureSearchControl"
              placeholderLabel="Search measures..."
              noEntriesFoundLabel="No measures found"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option
            (click)="toggleAllSelection()"
            [value]="'all'"
            [class.selected]="allSelected"
          >
            All
          </mat-option>
          <mat-option
            (click)="itemClicked()"
            *ngFor="
              let measure of filteredUniqueMeasures$ | async;
              let i = index
            "
            [value]="measure.name"
            >{{ measure.name }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Provider</mat-label>
        <mat-select
          multiple
          [(ngModel)]="filters.clinician"
          panelClass="searchable-panel"
        >
          <mat-option disabled>
            <ngx-mat-select-search
              [formControl]="clinicianSearchControl"
              placeholderLabel="Search Providers..."
              noEntriesFoundLabel="No Providers Found"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option
            (click)="toggleAllProviders()"
            [value]="'all'"
            [class.selected]="allProvidersSelected"
          >
            All
          </mat-option>
          <mat-option
            (click)="clinicianClicked()"
            *ngFor="let provider of filteredProviders$ | async; let i = index"
            [value]="provider.npi"
            >{{ provider.lastName }}, {{ provider.firstName }} <br />(NPI:
            {{ provider.npi }})
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Location</mat-label>
        <mat-select
          multiple
          [(ngModel)]="filters.location"
          panelClass="searchable-panel"
        >
          <mat-option disabled>
            <ngx-mat-select-search
              [formControl]="locationSearchControl"
              placeholderLabel="Search locations..."
              noEntriesFoundLabel="No locations found"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option
            (click)="toggleAllLocations()"
            [value]="'all'"
            [class.selected]="allProvidersSelected"
          >
            All
          </mat-option>
          <mat-option
            (click)="locationClicked()"
            *ngFor="let location of filteredLocations$ | async; let i = index"
            [value]="location.serviceLocationID.toString()"
            >{{ location.serviceLocationName }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="false" appearance="outline">
        <mat-label>Select Group</mat-label>
        <mat-select [(ngModel)]="filters.selectGroup">
          <mat-option value="option1">Option 1</mat-option>
          <mat-option value="option2">Option 2</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Measure Year</mat-label>
        <mat-select [(ngModel)]="filters.measureYear">
          <mat-option
            *ngFor="let year of years; let i = index"
            [value]="year"
            >{{ year }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <button
        mat-raised-button
        color="accent"
        (click)="applyFilters()"
        class="apply-filters-btn"
      >
        Apply Filters
      </button>
    </div>
  </div>

  <!-- Legend Section -->
  <div class="legend-section">
    <button class="legend-toggle" (click)="isLegendExpanded = !isLegendExpanded">
      <span class="legend-toggle-label">Dashboard Legend</span>
      <mat-icon>{{ isLegendExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    <div class="legend-content" *ngIf="isLegendExpanded">
      <div class="legend-items-row">
        <div class="legend-item-large">
          <span class="mips-indicator">M</span>
          <div class="legend-item-text">
            <span class="legend-item-label">MIPS Measure</span>
            <span class="legend-item-description">Included in Merit-based Incentive Payment System</span>
          </div>
        </div>
        <div class="legend-item-large">
          <span class="inverse-indicator">↓</span>
          <div class="legend-item-text">
            <span class="legend-item-label">Inverse Measure</span>
            <span class="legend-item-description">Lower values indicate better performance</span>
          </div>
        </div>
        <div class="legend-item-large">
          <span class="small-sample-indicator">*</span>
          <div class="legend-item-text">
            <span class="legend-item-label">Small Sample</span>
            <span class="legend-item-description">Denominator less than 20 patients</span>
          </div>
        </div>
        <div class="legend-item-large">
          <mat-icon class="favorite-legend-icon">favorite</mat-icon>
          <div class="legend-item-text">
            <span class="legend-item-label">Favorited Measure</span>
            <span class="legend-item-description">Click the heart icon to add or remove a measure from your favorites</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="dashboard-content">
    <div class="section-header unselectable">
      <h2>Measure Performance</h2>
      <div class="benchmark-toggle">
        <mat-slide-toggle
          [(ngModel)]="showFavoritesOnly"
          (change)="onShowFavoritesOnlyChange()"
        >
          Show Favorites Only
        </mat-slide-toggle>
        <mat-slide-toggle [(ngModel)]="showBenchmarks">
          Show National and Registry Benchmarks
        </mat-slide-toggle>
        <div class="benchmark-legend">
          <div class="legend-item">
            <div class="legend-marker national"></div>
            <span>National Benchmark</span>
          </div>
          <div class="legend-item">
            <div class="legend-marker registry"></div>
            <span>Registry Benchmark</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading" id="spinner-container" class="loading-container">
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
      <div class="loading-text">Loading...</div>
    </div>

    <!-- Performance Charts with inline details -->
    <div class="performance-charts unselectable" *ngIf="!showPatientDetails">
      @for (measure of filteredMeasures; track measure.name; let i = $index) {
        <!-- Measure Row -->
        <div
          *ngIf="showMeasure(measure)"
          class="measure-row"
          (click)="onMeasureClick(measure, i)"
          [class.selected-row]="selectedMeasure?.name === measure?.name"
        >
          <div class="measure-id" [title]="measure.measureDescription">
            <div class="measure-name">
              <button
                mat-icon-button
                class="favorite-btn"
                [class.is-favorite]="isFavorite(measure.name)"
                (click)="toggleFavorite(measure, $event)"
                [attr.aria-label]="isFavorite(measure.name) ? 'Remove from favorites' : 'Add to favorites'"
              >
                <mat-icon>{{ isFavorite(measure.name) ? 'favorite' : 'favorite_border' }}</mat-icon>
              </button>
              <button
                *ngIf="measure.isMultiPerformance && measure.isMultiPerformanceParent"
                mat-icon-button
                class="expand-icon"
                (click)="toggleExpanded(measure, $event, i)"
                [attr.aria-label]="measure.expanded ? 'Collapse' : 'Expand'"
              >
                <mat-icon>{{ measure.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              {{ getDisplayName(measure) }}
              <span *ngIf="measure.isMIPS" class="mips-indicator">M</span>
              <span
                *ngIf="isInverseMeasure(measure)"
                class="inverse-indicator"
                title="Inverse measure (lower is better)"
              >↓</span>
              <span
                *ngIf="hasSmallDenominator(measure)"
                class="small-sample-indicator"
                title="Small sample size (denominator < 20)"
              >*</span>
            </div>
            <div class="measure-description" *ngIf="measure.measureDescription && (!measure.isMultiPerformance || measure.isMultiPerformanceParent)">
              {{ measure.measureDescription }}
            </div>
          </div>

          <div class="chart-container">
            <div
              class="performance-bar"
              [style.width.%]="(measure.performance ?? 0) * 100"
              [style.background-color]="
                getColor(
                  measure.name ?? '',
                  measure.performance ?? 0,
                  measure.registryBenchMark,
                  this.isInverseMeasure(measure)
                )
              "
            >
              <span
                class="performance-value"
                *ngIf="(measure.performance ?? 0) >= 0.05"
                >{{ (measure.performance ?? 0) * 100 | number: "1.0-2" }}%</span
              >
              <span
                class="performance-value outside"
                *ngIf="(measure.performance ?? 0) < 0.05"
                >{{ (measure.performance ?? 0) * 100 | number: "1.0-2" }}%</span
              >
            </div>
            <!-- Benchmarks -->
            <div
              class="benchmark-marker national"
              *ngIf="
                showBenchmarks &&
                measure.nationalBenchMark !== undefined &&
                measure.nationalBenchMark !== 0
              "
              [title]="measure.nationalBenchMark * 100"
              [style.left.%]="measure.nationalBenchMark * 100"
            ></div>
            <div
              class="benchmark-marker registry"
              *ngIf="showBenchmarks && measure.registryBenchMark !== undefined"
              [title]="measure.registryBenchMark * 100"
              [style.left.%]="measure.registryBenchMark * 100"
            ></div>
          </div>
        </div>

        @if (
          (showMeasureDetails || showPatientDetails) && selectedIndex === i
        ) {
          <!-- Measure Details Header -->
          <div class="details-header unselectable" id="measureDetailsAnchor">
            <div id="leftSideMeasureDetailsHeader">
              <mat-tab-group
                mat-align-tabs="start"
                (selectedTabChange)="
                  selectDetailsTab($event.tab.textLabel.toLowerCase())
                "
              >
                <mat-tab
                  label="MIPS Points Data"
                  [class.active]="selectedDetailsTab === 'mipsData'"
                >
                </mat-tab>
                <mat-tab
                  label="Patient Measures"
                  [class.active]="selectedDetailsTab === 'patientData'"
                  [disabled]="isTinAggregationEnabled"
                >
                </mat-tab>
                <mat-tab
                  label="Monthly Trend"
                  [class.active]="selectedDetailsTab === 'monthlyTrend'"
                >
                </mat-tab>
              </mat-tab-group>
              <div class="refresh-info">
                <p>Data last refreshed: {{ measure.createDate }}</p>
              </div>
            </div>
            <div class="header-actions">
              <button
                *ngIf="selectedDetailsTab === 'patientData'"
                mat-icon-button
                class="export-details"
                [disabled]="isExportingPatients"
                (click)="onExportDetails()"
              >
                <mat-icon>file_download</mat-icon>
              </button>
              <button
                mat-icon-button
                class="close-details"
                (click)="closeDetails()"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          @switch (selectedDetailsTab) {
            @case ("performanceData") {
              <!-- Measure Details Component with related measures for multi-performance support -->
              <app-measure-details-prod
                *ngIf="selectedMeasure"
                [measure]="selectedMeasure"
                [relatedMeasures]="getRelatedMeasures(selectedMeasure)"
                [showBenchmarks]="showBenchmarks"
                [isSmallPractice]="isSmallPractice"
                [deciles]="(deciles$ | async) ?? []"
                (close)="closeDetails()"
                (viewScoringMeasure)="onViewScoringMeasure($event)"
              >
              </app-measure-details-prod>
            }
            @case ("patientData") {
              <!-- Patient Measures Details Component -->
              <app-patient-measure-details-prod
                [measureName]="selectedMeasure?.name ?? ''"
                [populationNbr]="selectedMeasure?.populationNbr ?? null"
                [populationCount]="selectedMeasure?.populationCount ?? null"
                [filter]="getRequestFilter()"
                [orgID]="(this.organizationID$ | async) || ''"
                (close)="closePatientDetails()"
                (exportStarted)="isExportingPatients = true"
                (exportCompleted)="isExportingPatients = false"
              >
              </app-patient-measure-details-prod>
            }
            @case ("monthlyTrend") {
              <app-measure-monthly-trend></app-measure-monthly-trend>
            }
            @default {}
          }
        }
      }
    </div>

    <!-- Measures Without Results -->
    <div
      class="no-results-section"
      *ngIf="!showPatientDetails && measuresWithoutResults.length > 0"
    >
      <div
        class="no-results-header"
        (click)="isNoResultsSectionExpanded = !isNoResultsSectionExpanded"
        [attr.aria-expanded]="isNoResultsSectionExpanded"
      >
        <mat-icon class="no-results-toggle-icon">{{
          isNoResultsSectionExpanded ? "expand_less" : "expand_more"
        }}</mat-icon>
        <h3>No distinct patient population identified</h3>
      </div>

      <div *ngIf="isNoResultsSectionExpanded" class="no-results-body">
        <p class="no-results-subtitle">
          This section displays measures that do not have results and do not
          display in the measure section. e.g. Denominator is 0.
        </p>
        <div
          class="no-results-row"
          *ngFor="let measure of measuresWithoutResults"
        >
          <div class="no-results-id-cell">
            <span class="no-results-label">Measure ID:</span>
            <a
              *ngIf="measure.url"
              [href]="measure.url"
              target="_blank"
              rel="noopener noreferrer"
              class="measure-spec-link"
              (click)="$event.stopPropagation()"
            >{{ measure.name }}</a>
            <span *ngIf="!measure.url">{{ measure.name }}</span>
          </div>
          <div class="no-results-desc-cell">
            <span class="no-results-label">Measure:</span> {{ measure.measureDescription }}
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
